<div class="metricas-container">
  <header class="page-hero">
    <span class="hero-icon">
      <mat-icon>insights</mat-icon>
    </span>
    <div class="hero-texto">
      <h1>Painel de Métricas</h1>
      <p>Acompanhe todos os indicadores das obras do seu time.</p>
    </div>

    <div class="hero-acoes">
      <button type="button" class="btn-hero" (click)="exportAllExcels()">
        <mat-icon>download</mat-icon>
        EXPORTAR
      </button>
    </div>
  </header>

  <div class="filtros-metricas">
    <app-filtro-responsavel
      [responsavel]="responsavel"
      [(filtroResponsavel)]="selectedUsuario"
      (responsavelIdChange)="onResponsavelIdChange($event)"
      (responsaveisChange)="onResponsaveisRecebidos($event)"
      [isMaster]="true"
      class="filtro-res"
    ></app-filtro-responsavel>

    <app-filtro-periodo
      [intervaloSelecionado]="intervaloSelecionado"
      [config]="config"
      (intervaloSelecionadoChange)="onPeriodoSelecionadoChange($event)"
    ></app-filtro-periodo>
  </div>

  <div class="mb-4">
    <app-obras-por-fase
      [selectedPeriodo]="intervaloSelecionado"
      [obraIds]="obraIds"
      [responsavel]="responsavel"
      (obraSelecionada)="onObraSelecionada($event)"
      (companyNameClick)="onCompanyNameClick($event)"
      (atualizandoMetricasChange)="onAtualizandoMetricasChange($event)"
    ></app-obras-por-fase>
  </div>
  <div class="mb-4">
    <app-obras-por-tarefas
      [selectedPeriodo]="intervaloSelecionado"
      [obraIds]="obraIds"
      [responsavel]="responsavel"
      (obraSelecionada)="onObraSelecionada($event)"
      (companyNameClick)="onCompanyNameClick($event)"
      (atualizandoMetricasChange)="onAtualizandoMetricasChange($event)"
    ></app-obras-por-tarefas>
  </div>
  @if (acessoMapaComparativo === true) {
  <div class="mb-4">
    <app-mapa-comparativo
      [selectedPeriodo]="intervaloSelecionado"
      [responsavel]="responsavel"
      (atualizandoMetricasChange)="onAtualizandoMetricasChange($event)"
    ></app-mapa-comparativo>
  </div>
  }

  <div class="mb-4">
    <app-motivos-perda
      [selectedPeriodo]="intervaloSelecionado"
      [obraIds]="obraIds"
      [responsavel]="responsavel"
      (obraSelecionada)="onObraSelecionada($event)"
      (companyNameClick)="onCompanyNameClick($event)"
      (atualizandoMetricasChange)="onAtualizandoMetricasChange($event)"
    ></app-motivos-perda>
  </div>

  <div class="mb-4">
    <app-vendas-regiao
      [selectedPeriodo]="intervaloSelecionado"
      [obraIds]="obraIds"
      [responsavel]="responsavel"
      (obraSelecionada)="onObraSelecionada($event)"
      (companyNameClick)="onCompanyNameClick($event)"
      (atualizandoMetricasChange)="onAtualizandoMetricasChange($event)"
    ></app-vendas-regiao>
  </div>
  <div class="mb-4">
    <app-obras-responsaveis
      [selectedPeriodo]="intervaloSelecionado"
      [obraIds]="obraIds"
      [responsavel]="responsavel"
      (obraSelecionada)="onObraSelecionada($event)"
      (companyNameClick)="onCompanyNameClick($event)"
      (atualizandoMetricasChange)="onAtualizandoMetricasChange($event)"
    ></app-obras-responsaveis>
  </div>
</div>
<app-common-loader *ngIf="atualizandoMetricas"></app-common-loader>
<app-loader-metrics *ngIf="downloadExportar"></app-loader-metrics>

